module.exports = __webpack_public_path__ + "img/amex.47010580.svg";